import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener} from '@angular/core'
import {faTimes} from '@fortawesome/pro-light-svg-icons/faTimes'
import {LinkService} from '../../../../i18n/link.service'
import {PUBLIC_ROUTES} from '../../../../../shared/routing/public.routes'
import {AuthStatusService} from '../../../../auth/auth-status.service'
import {filter} from 'rxjs/operators'
import {NavigationEnd, Router, RouterLink, RouterLinkActive} from '@angular/router'
import {faLock} from '@fortawesome/pro-solid-svg-icons/faLock'
import {faShieldCheck} from '@fortawesome/pro-solid-svg-icons/faShieldCheck'
import {TranslocoDirective} from '@ngneat/transloco'
import {AsyncPipe, NgClass, NgOptimizedImage} from '@angular/common'
import {FaIconComponent} from '@fortawesome/angular-fontawesome'
import {HeroSearchbarComponent} from '../../../../../craft/hero-searchbar/hero-searchbar.component'
import {NavListModule} from '../../../../../craft/nav-list/nav-list.module'
import {TopicOverviewSubmenuComponent} from './topic-overview-submenu/topic-overview-submenu.component'
import {LoadableModule} from '../../../../lazy-loading/loadable.module'
import {LanguagePickerModule} from '../../language-picker/language-picker.module'
import {SideMenuService} from '../side-menu.service'
import {takeUntilDestroyed} from '@angular/core/rxjs-interop'
import {PrioritizedUserRolePipe} from '../../../../../shared/pipes/prioritized-user-role.pipe'

@Component({
  selector: 'bgo-navbar-side-menu',
  templateUrl: './navbar-side-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TranslocoDirective,
    AsyncPipe,
    NgClass,
    FaIconComponent,
    NgOptimizedImage,
    HeroSearchbarComponent,
    NavListModule,
    RouterLink,
    RouterLinkActive,
    TopicOverviewSubmenuComponent,
    LoadableModule,
    LanguagePickerModule,
    PrioritizedUserRolePipe,
  ],
})
export class NavbarSideMenuComponent {
  readonly closeIcon = faTimes
  readonly proSignupIcon = faLock
  readonly satisfactionGuaranteeIcon = faShieldCheck

  readonly APPLICATION_ROUTES = PUBLIC_ROUTES
  readonly satisfactionGuaranteeLink = this.linkService.happinessGuaranteePagePath

  @HostListener('window:keyup.esc', ['$event'])
  closeOnEsc() {
    this.sideMenuService.hide()
  }

  constructor(
    readonly linkService: LinkService,
    readonly authStatus: AuthStatusService,
    readonly sideMenuService: SideMenuService,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: Router,
  ) {
    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(_ => {
        this.sideMenuService.hide()
      })
  }

  detectChanges(): void {
    this.cdr.detectChanges()
  }

  openSearch() {
    this.sideMenuService.hide()
    this.linkService.navigateTo(PUBLIC_ROUTES.SEARCH)
  }
}
